/** Bundled pet license cart / Municipay checkout: applicants (vendor permit role) only. */
export function canUsePetLicenseBundleCheckout (
  permitScopedRole: string | undefined,
  globalUserRole: string | undefined
): boolean {
  return (
    permitScopedRole === 'Vendor' &&
    globalUserRole !== 'Admin' &&
    globalUserRole !== 'Super Admin'
  );
}
